<template>
    <div>
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <div class="content c-top">
            <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="礼包名称" prop="name">
                        <el-input style="width: 232px" v-model="searchForm.name" placeholder="请输入礼包名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="礼包编号" prop="code">
                        <el-input style="width: 232px" v-model="searchForm.code" placeholder="请输入礼包编号" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品名称" prop="goodsName">
                        <el-input style="width: 232px" v-model="searchForm.goodsName" placeholder="请输入商品名称"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select style="width: 232px" v-model="searchForm.status" placeholder="请选择状态" filterable
                            clearable>
                            <el-option label="启用中" value="1"></el-option>
                            <el-option label="已停用" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="礼包类目" prop="categoryNos">
                        <el-select style="width: 232px" v-model="categoryNos1" placeholder="请选择礼包类目" filterable clearable>
                            <el-option v-for="(item, index) in categoryIds" :key="index" :label="item.categoryName"
                                :value="item.categoryNo"></el-option>
                        </el-select>
                        <!-- <el-cascader style="width: 232px" :options="categoryIds" v-model="searchForm.categoryId"
                            :props="{ checkStrictly: true, multiple: true, emitPath: false }" collapse-tags
                            clearable></el-cascader> -->
                    </el-form-item>
                    <el-form-item label="关联标签" prop="tagId">
                        <el-cascader style="width: 232px" :options="tagIds1" v-model="searchForm.tagLevel2"
                            placeholder="请选择关联标签" :props="{ checkStrictly: false, multiple: true, emitPath: false }"
                            collapse-tags clearable></el-cascader>
                    </el-form-item>
                    <el-form-item label="创建时间" prop="createdTimeStart">
                        <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div style="display: flex;">
                    <div style="display: flex;line-height: 40px;color: #333333;font-size: 14px;">
                        <div>个人复购佣金:{{ rate }}%</div>
                        <div style="margin-left: 20px;margin-right: 30px;color: #2d46ee;cursor: pointer;"
                            @click="settingRate">设置</div>
                    </div>
                    <el-button type="primary" :loading="exporting" @click="add('add')" icon="el-icon-plus">新增</el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog title="个人复购佣金设置" :visible.sync="isSetting" width="518px" :append-to-body="true">
            <template>
                <div class="info" style="text-align: left">
                    <el-form>
                        <el-form-item label="个人复购比例">
                            <el-input style="width: 370px;" placeholder="请输入个人复购比例"
                                v-model="personelRepurchaseRate"><template slot="append">%</template></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isSetting = false">取消</div>
                    <div class="info-s" @click="submitSetting">确定</div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        LbTable,
    },
    data() {
        return {
            personelRepurchaseRate: '',
            isSetting: false,
            goodsList: [

            ],
            dialogGoods: false,
            isS: false,
            dataList: {
                list: [
                    { title: '商品管理', path: '', type: '0' },
                    { title: '礼包管理', path: '/shopManagement/giftManagement', type: '1' }
                ]
            },
            searchList: {
                list: [
                    { title: '礼包管理', path: '', type: '0' },
                    { title: '数据筛选', path: '', type: '1' }
                ]
            },
            list: [],
            searchForm: {
                name: '',
                status: '',
                code: '',
                goodsName: null,
                // categoryId: null,
                tagLevel2: [],
                createTimeStart: "",
                createTimeEnd: '',
                nameOrGoodsNo: '',
                pageNo: 1,
                pageSize: 10,
                // categoryNos:[]
            },
            value1: [],
            value2: [],
            brandList: [],
            columns: [
                {
                    label: '礼包信息',
                    width: '300',
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;">
                                <el-image style="width:64px;height:64px;margin-right:8px;" src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
                                <div style="text-align:left;flex:1;">
                                    <div style="width:100%;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;text-overflow:ellipsis;overflow:hidden;">
                                        {scope.row.name}
                                    </div>
                                    <p>商品编号：{scope.row.code}</p>
                                </div>
                            </div>
                        )
                    }
                },
                {
                    label: '关联标签', prop: 'tagLevel2', minWidth: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                <p style="max-height: 60px;line-height:30px; overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">{scope.row.tagLevel2 ? scope.row.str : '--'}</p>
                            </div>
                        )
                    }
                },
                {
                    label: '商品', prop: 'goodsNames', minWidth: '200',
                    render: (h, scope) => {
                        return (
                            <div>
                                <p style="max-height: 120px;line-height:30px; overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;">{scope.row.goodsNames ? scope.row.goodsNames : '--'}</p>
                            </div>
                        )
                    }
                },
                {
                    label: '礼包类目', prop: 'categoryNames', minWidth: '120',
                },
                { label: '库存', prop: 'stock', minWidth: '100' },
                { label: '价格', prop: 'price', minWidth: '120' },
                { label: '赠送积分', prop: 'points', minWidth: '130' },
                {
                    label: '佣金比例', prop: 'firstCommissionProportion', minWidth: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.firstCommissionProportion}%,{scope.row.secondCommissionProportion}%,{scope.row.thirdCommissionProportion}%
                            </div >
                        )
                    }
                },
                {
                    label: '状态', prop: 'statusLabel', minWidth: '130',
                    render: (h, scope) => {
                        let vv = ''
                        if (scope.row.statusLabel == '启用') {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusLabel}</div>
                            </p>
                        } else {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background:  #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusLabel}</div>
                            </p>
                        }
                        return (
                            <div> {vv}</div>
                        )
                    }
                },
                {
                    label: '有效期', prop: 'validityEndTime', minWidth: '320',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.row.validityStartTime || '--'}-{scope.row.validityEndTime || '--'}
                            </div >
                        )
                    }
                },
                { label: '创建时间', prop: 'createdTime', minWidth: '200' },
                {
                    label: '操作',
                    minWidth: '120',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.add('edit', scope.row.id) }}>编辑</span>
                                <span style='color:#2D46EE;cursor:pointer;margin-left:10px' onClick={() => { this.add('look', scope.row.id) }}>查看详情</span>
                            </div >
                        )
                    }
                }],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            page1: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            goodsSearch: {
                tagId: '',
                pageNo: 1,
                pageSize: 10,
            },
            exporting: false,
            sName: '启用',
            isStatus: '',
            tagId: null,
            categoryIds: [],
            tagIds: [],
            tagIds1: [],
            rate: 0,
            categoryNos1: ''
        }
    },
    created() {
        this.getPageList()
        this.getCategoryList()
        this.getTagList()
        this.getRate()
    },
    beforeRouteEnter(to, from, next) {
        if (from.name == 'addTag') {
            next(vm => {
                vm.getPageList();
            });
        } else {
            next(vm => {
                vm.getPageList();
            });
        }
    },
    methods: {
        getRate() {
            this.axios.post('/giftPackage/getPersonelRepurchase', {})
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.rate = res.data
                    }
                })
        },
        submitSetting() {
            let data = {
                personelRepurchaseRate: this.personelRepurchaseRate
            }
            this.axios.post('/giftPackage/setPersonelRepurchase', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('设置成功')
                        this.isSetting = false
                        this.getRate()
                    }
                })
        },
        getCategoryList() {
            let data = {
                pageNo: 1,
                pageSize: 10000,
                // categoryName: '',
                // categoryNo: '',
                // status: null
            }
            this.axios.post('/giftPackage/getFirstCategory', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.categoryIds = res.data
                    }
                })
        },
        getTagList() {
            this.tagIds = []
            this.axios.post('/tagPool/filter/categoryList', {})
                .then(res => {
                    res.data.forEach(item => {
                        let obj = {
                            value: item.dictId,
                            label: item.dictName,
                            children: []
                        }
                        this.tagIds.push(obj)
                    })
                    this.getSecondTag()
                })
        },
        getSecondTag() {
            let data = {
                pageNo: 1,
                pageSize: 100000
            }
            this.axios.post('/tagPool/filter/pageList', data)
                .then(res => {
                    this.tagIds2 = res.data.list
                    res.data.list.forEach(item => {
                        item.id = String(item.id)
                        item.label = item.name
                        this.tagIds.forEach(itm => {
                            if (item.pid == itm.value) {
                                let obj = {
                                    value: item.id,
                                    label: item.label,
                                }
                                itm.children.push(obj)
                            }
                        })
                    })

                    this.tagIds1 = this.tagIds
                    console.log(this.tagIds1)
                })
        },
        settingRate() {
            this.isSetting = true
            this.personelRepurchaseRate = this.rate
        },
        deleteG(id) {
            let msg = '是否确认删除该商品？'
            this.$confirm(msg, '温馨信息', {
                title: '温馨信息',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.axios.post('/tags/deleteTagGood', { id: id })
                    .then(res => {
                        console.log(res)
                        if (res.code == 0) {
                            this.$message.success('删除成功')
                            this.getShopList()
                            this.getPageList()
                        }
                    })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        add(type, val) {
            this.$router.push({
                name: 'giftEdit',
                query: {
                    id: val,
                    type: type
                }
            })
        },
        getShopList() {
            this.goodsSearch.pageNo = this.page1.pageNo
            this.goodsSearch.pageSize = this.page1.pageSize
            this.axios.post('/tags/getGoodsPageByTag', this.goodsSearch)
                .then(res => {
                    console.log(res)
                    this.goodsList = res.data.list;
                    this.page1.totalNum = res.data.totalNum;

                })
        },
        look(id) {
            this.dialogGoods = true
            this.goodsSearch.tagId = id
            this.getShopList()
        },
        isStart(val) {
            this.isS = true
            this.sName = val.statusL
            this.tagId = val.id
            if (val.statusL == '启用') {
                this.isStatus = true
            } else {
                this.isStatus = false
            }

        },
        upStatus() {
            let data = {
                id: this.tagId,
                status: this.isStatus,
            }
            this.axios.post('/tags/updateStatus', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                        this.isS = false
                        this.getPageList()
                    }

                })
        },
        exportFn() {
            this.exporting = true
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.joinTimeStart = this.value1[0];
                this.searchForm.joinTimeEnd = this.value1[1];
            } else {
                this.searchForm.joinTimeStart = ''
                this.searchForm.joinTimeEnd = ''
            }
            if (this.value2) {
                this.searchForm.lastActiveTimeStart = this.value2[0];
                this.searchForm.lastActiveTimeEnd = this.value2[1];
            } else {
                this.searchForm.lastActiveTimeStart = ''
                this.searchForm.lastActiveTimeEnd = ''
            }
            this.axios.post('/users/exportList', this.searchForm)
                .then(res => {
                    console.log(res)
                    this.exporting = false;
                    if (res.code === 0) {
                        this.downloadlink(res.data)
                    }
                })
        },
        fetchData(type) {
            this.page.pageNo = 1;
            if (type == 'reset') {
                this.$refs['searchForm'].resetFields()
                this.value1 = []
                this.searchForm.createTimeStart = ''
                this.searchForm.createTimeEnd = ''
                // this.tagIds1 = []
                this.searchForm.tagLevel2 = []
                this.categoryNos1 = ''

            }
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.createTimeStart = this.value1[0];
                this.searchForm.createTimeEnd = this.value1[1];
            } else {
                this.searchForm.createTimeStart = ''
                this.searchForm.createTimeEnd = ''
            }

            if (this.categoryNos1 != '') {
                this.searchForm.categoryNos = []
                this.searchForm.categoryNos.push(this.categoryNos1)
            } else {
                this.searchForm.categoryNos = []
                delete this.searchForm.categoryNos
            }
            this.getPageList()
        },
        getPageList() {
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.createTimeStart = this.value1[0];
                this.searchForm.createTimeEnd = this.value1[1];
            } else {
                this.searchForm.createTimeStart = ''
                this.searchForm.createTimeEnd = ''
            }
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            this.axios.post('/giftPackage/pageList', this.searchForm)
                .then(res => {
                    res.data.list.forEach(e => {
                        // e.marketPrice = Number(e.marketPrice)
                        // e.stock = Number(e.stock)
                        // e.soldNum = Number(e.soldNum)
                        e.mainImageArr = []
                        e.mainImageArr.push(e.images)
                        // if (e.isMyOutput == 1) {
                        //     e.isMyOutputLabel = '平台上架'
                        // } else {
                        //     e.isMyOutputLabel = '五域上架'
                        // }
                        // if (e.tagNames) {
                        //     e.tagNames = e.tagNames
                        // } else {
                        //     e.tagNames = '-'
                        // }
                        // e.skuList.forEach(it => {
                        //     it.skuNo = e.goodsNo + it.skuNo
                        // })
                        // // e.statusL = false
                        // if (e.status == 1) {
                        //     e.statusL = true
                        // } else {
                        //     e.statusL = false
                        // }
                        let str = ''
                        if (e.tagLevel2) {
                            for (let i = 0; i < e.tagLevel2.length; i++) {
                                if (i <= 0) {
                                    str = e.tagLevel2[i]
                                } else {
                                    str = str + ',' + e.tagLevel2[i]
                                }
                            }

                            e.str = str
                        }
                    })

                    this.list = res.data.list;
                    this.page.totalNum = res.data.totalNum;
                })
        },
        onMultipleSelection(e) { },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.page.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e;
            this.getPageList()
        },
        handleSizeChange1(e) {
            this.page1.pageSize = e;
            this.page1.pageNo = 1;
            this.getShopList()
        },
        handleCurrentChange1(e) {
            this.page1.pageNo = e;
            this.getShopList()
        },
        todetail(row) {
            this.$router.push({
                name: 'userDetail',
                query: {
                    id: row.id
                }
            })
        }
    }
}
</script>
<style>
/* .el-cascader-panel {
    .el-scrollbar:first-child {
        .el-checkbox {
            display: none;
        }
    }
} */
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
    color: #2d46ee;
    ;
    font-weight: 700;
}

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
    color: #2d46ee;
    font-weight: 700;
}

.el-cascader__suggestion-item.is-checked {
    color: #2d46ee;
    font-weight: 700;
}
</style>
<style scoped lang="scss">
.start {
    width: 10px;
    height: 10px;
    background: #13ce4b;
    border-radius: 50%;
    opacity: 1;
    margin-top: 8px;
    margin-right: 5px;
}

.end {
    width: 10px;
    height: 10px;
    background: #f63c56;
    border-radius: 50%;
    opacity: 1;
    margin-top: 8px;
    margin-right: 5px;
}

/deep/ .el-dialog {
    // display: flex;
    // flex-direction: column;
    // margin: 0 !important;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // -webkit-transform: translate(-50%, -50%);
    // -moz-transform: translate(-50%, -50%);
    // transform: translate(-50%, -50%);
    // max-height: calc(100% - 30px);
    // max-width: calc(100% - 30px);

    // .el-dialog__body {
    //     padding: 30px 25px;
    //     height: 800px;
    //     flex: 1;
    //     overflow: auto;
    // }
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

::v-deep .el-input--prefix .el-input__inner {
    padding-left: 37px;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}

.search-form {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 100px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 100px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }

    .form-btn {
        /deep/ .el-form-item__content {
            line-height: 36px;
            margin-left: 50px;
        }
    }
}

/deep/ .el-table__row {
    .el-table__cell {
        padding: 12px 0;
    }
}

/deep/ .el-table {
    color: #303033;
}
</style>
  
  